"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Pin = function Pin(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "PinTitle PinDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "PinTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "PinDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M13.61 17.42c.338-.512.487-1.074.43-1.56-.043-.355-.046-.846.158-1.14l3.096-4.457c.204-.294.381-.521.395-.507l.026.025c.393.393 1.07.389 1.68.041.312-.176.309-.598.055-.851l-4.786-4.786c-.253-.253-.675-.257-.851.054-.347.612-.352 1.288.042 1.682l.025.025c.014.014-.213.191-.508.395L8.916 9.437c-.295.204-.785.202-1.14.16-.487-.059-1.048.09-1.56.428-.3.197-.296.616-.043.869L9.01 13.73l-3.15 3.15.006.008c-1.262 1.33-2.062 2.522-1.824 2.76.238.238 1.43-.562 2.76-1.825l.007.007 3.151-3.15 2.781 2.781c.254.253.672.257.87-.043z"
  }));
};

Pin.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Pin.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Pin;
exports["default"] = _default;